import { LocationsManagerPopup } from './locationsManagerPopup';

const props = [
];

export const LocationsManagerDialogDirective = reactDirective => reactDirective(LocationsManagerPopup, props);
LocationsManagerDialogDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('locationsManagerDialog', LocationsManagerDialogDirective);
